export default __webpack_public_path__ + "1d7d2ed.png";